import * as z from "zod/v4";

export const disconnectWalmartIntegration = {
  name: "disconnectWalmartIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
